import { NEW_OBJECT_ID_TOOL_NAME } from "@redotech/redo-agents-common/code-mode-tool-names";
import {
  marketingAutomationSendEmailPatch,
  marketingAutomationStepUpdateOp,
} from "@redotech/redo-marketing-sdk/schema/automation-step-ops";
import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import { schemaKey } from "@redotech/zod-util/schema-key";
import { updateAutomationSteps } from "../automations/update-automation-steps";

export const createEmailTemplate = {
  name: "createEmailTemplate" as const,
  description: `Creates an email template for the team. To use it in the same script, for example as the ${schemaKey(marketingAutomationSendEmailPatch, "templateId")} of a ${schemaKey(marketingAutomationStepUpdateOp, "sendEmail")} step in ${updateAutomationSteps.name}, set its ${schemaKey(emailTemplateSchema, "_id")} to an id from ${NEW_OBJECT_ID_TOOL_NAME} first.`,
  mutates: true,
  input: emailTemplateSchema.partial({ _id: true }),
  output: emailTemplateSchema,
};
